import { Component, Input } from '@angular/core';

@Component({
  selector: 'cerrix-title',
  templateUrl: './cerrix-title.component.html',
  styleUrls: ['./cerrix-title.component.scss']
})
export class CerrixTitleComponent{
  @Input() text : string;

}
